import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Algo deu errado");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="grid-bg min-h-[85vh] flex items-center px-4 py-16">
      <div className="max-w-md mx-auto w-full">
        <span className="sticker">DE VOLTA</span>
        <h1 className="font-bebas text-6xl mt-6 tracking-tighter">ENTRAR</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="login-email" required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" className="brutal-input"/>
          <input data-testid="login-password" required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Senha" className="brutal-input"/>
          <button data-testid="login-submit" disabled={loading} className="brutal-btn w-full">{loading? "Verificando..." : "Entrar"}</button>
        </form>
        <p className="mt-6 text-white/60 font-manrope">
          Ainda não tem conta? <Link data-testid="login-to-register" to="/register" className="text-[#CCFF00] underline">Cria uma aqui</Link>
        </p>
        <p className="mt-2 text-white/50 font-manrope text-sm">
          <Link data-testid="login-to-forgot" to="/forgot-password" className="text-white/70 underline hover:text-[#CCFF00]">Esqueci minha senha</Link>
        </p>
      </div>
    </div>
  );
}
